module.exports = {
  // 左侧菜单栏配置
  menus: {
    a1:'质量',
    a2:'品类',
    a3:'库存',
    a4:'配送',
    b1:'品质保证、认证商户假一赔三',
    b2:'品类齐全，一站到齐',
    b3:'即时库存，保证有货',
    b4:'属地汽配商服务',
    center: '个人中心',
    Home: '后台首页',

    orders: '我的订单',
    bought: '我买到的',
    sold: '我卖出的',

    management: '店铺管理',
    shopList: '店铺列表',
    Information: '店铺信息',
    construction: '店铺装修',
    warehouse: '仓库库存',

    marketing: '营销管理',
    Events: '店铺活动',

    Account: '账号管理',
    personal: '个人资料',
    address: '收货地址',
    Invoice: '发票设置',

    organization: '组织管理',
    employee: '员工列表',
    role: '角色管理',

    Financial: '财务管理',
    selfOperated: '自营挂账',
    Union: '联盟挂账',
  },

  // 顶部、右侧导航栏
  navigation: {
  },

  // ZF首页
  home: {
    Accessories: '配件查询',
    store: '店铺查询',
    VIN: 'VIN码查询',
    search: '搜索',
    placeholder1: '请输入店铺名称',
    placeholder2: '请输入17位VIN码',
    placeholder3: '请输入配件编码/配件名称。配件编码支持多个查询，请用Ctrl+Enter隔开。',
    stores: '门店',
    Only: '只显示有货',

    Information: '基本信息',
    place: '发货地',
    stock: '库存',
    price: '价格',
    Purchase: '购买数量',
    operate: '操作',
    Bar:'条/页',

    return: '返回首页',
    quit: '退出',
    welcome: '欢迎',
    quote: '询报价',
    cart: '购物车',
    personal: '个人中心',
    focus: '我的关注',
    Back: '返回顶部',
    immediately: '立即购买',
    Inquire: '立即询价',
    info: '没找到您想要的数据',
    service: '服务：',
    oemCode: 'OEM码：',
    all:'全部',
  },

  // 商品详情
  detail: {
    price: '价格',
    Inquire: '询价',
    discount: '优惠',
    Serve: '服务',
    stock: '库存',
    MOQ: '起订量',
    Purchase: '购买数量',
    product: '商品详情',
    Applicable: '适用车型',
    Accessory: '配件描述',
    selling: '本店热销',
    Monthly: '月销量',
    Buy: '购买',
    Home: '店铺首页',
    products: '全部商品',
    Search: '搜索本店',
    placeholder: '请输入配件编码/配件名称',
    accessories: '暂无配件描述',
    Inventory: '库存不足',
    cart: '加入购物车',
    now: '立即购买',
    InquireNow: '立即询价',

    // 表格
    code: '配件编码',
    brand: '品牌',
    standard: '标准分组',
    alias: '别名',
    Related: '关联原厂件',
    type: '配件类型',
    unit: '单位',
    name: '标准名称',
    carBrand: '车厂牌',
    OEM: '主机厂',
    series: '车系',
    model: '车型',
    modelName: '车型名称',
    payment: '年款',
    Displacement: '排量',
    gearbox: '变速箱',
    gear: '档位',
    engine: '发动机',
    info: '暂无配件描述',
  },

  // 询价页面
  Inquiry: {
    list: '询价列表',
    Quote: '报价列表',

    // 表格
    number: '单号',
    state: '状态',
    information: '询价信息',
    product: '商品信息',
    place: '发货地',
    quantity: '询价数量',
    QuoteInfo: '报价信息',
    price: '单价',
    amount: '金额',
    operate: '操作',
    Inquirer: '询价人',
    search: '搜索',
    Accessory: '配件编码/配件名称',
    OE: 'OE号'
  },

  // 购物车页面
  shopping: {
    cart: '购物车',
    Inquiry: '询价购物车',

    // 表格
    picture: '商品图片',
    info: '商品信息',
    place: '发货地',
    stock: '库存',
    price: '单价(元)',
    Purchase: '购买数量',
    Subtotal: '小计(元)',
    operate: '操作',

    select: '全选',
    delete: '删除',
    No: '暂无数据',
    selected: '已选商品',
    pieces: '件',
    Total: '合计(不含运费)',
    settlement: '结算',
    Sorry: '抱歉!您的购物车空空如也~',
    Expired: '失效商品',
    Bulk: '批量导入购物车'
  },

  // 订单提交页面
  orderInformation: {
    address: '确认收货地址',
    New: '新增收货地址',
    Change: '修改地址',
    default: '默认地址',
    More: '更多地址',
    Confirm: '确认订单信息',

    // 表格
    Information: '基本信息',
    place: '发货地',
    price: '单价(元)',
    Purchase: '购买数量',
    Subtotal: '小计(元)',
    method: '运送方式',
    Logistics: '物流快递',
    pick: '上门自取',
    Postage: '邮费默认到付，具体请和卖家联系',
    Non: '非自营、非联盟商品不能使用挂账，请分开提交订单',
    Total: '实付款',
    real: '提交订单',
    freight: '应付合计（不含运费）',
    fee: '店铺合计（不含运费）',
    Message: '给卖家留言',
    workOrderCode:'工单号',
    Optional: '选填，请先和商家协商一致',
    invoice: '发票类型',
    info: '发票信息',
    Reselect: '重新选择',
    VAT: '增值税专用发票',
    General: '增值税普通发票',
    ticket: '专票',
    Popular: '普票',
    supplier: '供应商发票',
    noInvoice: '不开发票',
    invoicing: '开票金额不包含运费',
    delivery: '运费到付，以卖家发货物流公司为准',
    Please: '请先到个人中心-发票管理中维护发票信息',
    latest: '请返回购物车重新获取最新价格',
  },

  //我的订单
  myOrder: {
    
    allOrders: '所有订单',
    pendingPayment: '待付款',
    waitDelivery: '待发货',
    waitReceived: '待收货',
    completion: '交易完成',
    returnGoods: '退款/退货',
    claimApplication: '理赔申请',
    orderNo: '订单编号',
    partName: '配件编码或名称',
    shopName: '店铺名称',
    selectDate: '选择下单日期',
    clerk: '下单员',
    reset: '重置',
    query: '查询',
    status: '订单状态',
    statusAll: "全部",
    statusClose: '交易关闭',
    statusCancel: '交易取消',
    product: '商品信息',
    place: '发货地',
    num: '数量',
    price: '单价(元)',
    productStatus: '商品状态',
    payInfo: '付款信息',
    operate: '操作',
    export: '导出',
    orderDetails: '订单详情',
    buyAgain: '再次购买',
    applyReturn: '申请退款',
    sellReturn: '查看申请',
    cancelReturn: '撤销申请',
    print: '打印',
    Claim: '理赔单状态',

    Withdrawal: '撤销理赔',
    View: '查看理赔',
    completed: '理赔完成',
    Denied: '理赔拒绝',
    application: '理赔申请',
    goods: '商品金额',
    actually: '实付金额',
    Return: '退货金额',
    Refund: '退款金额',
    amount: '理赔金额',
    Payment: '付款',
    cancel: '取消订单',
    receiving: '收货',
    viewApplication: '查看申请',
    canceled: '撤销申请',
    Request: '申请退款',
    Apply: '申请售后',
    buy: '再次购买',
    automatic: '自动收货',

    left: '还剩',
    day: '天',
    Hour: '小时',
    point: '分',
    Second: '秒',
    order: '订单号',
    Number: '理赔单号',
    quantity: '数量',
    yuan: '单价(元)',
    commodity: '商品状态',
    info: '付款信息',
    transaction: '交易操作',
  },


  //店铺管理--->店铺列表
  storeList: {
    registeredCompany: "注册公司",
    companyStatus: '公司状态',
    companyName: '店铺名称',
    default: '默认店铺',
  },

  //店铺管理--->店铺信息
  storeInfo: {
    baseInfo: '基础信息',
    mainInfo: '主营信息',
    attestation: '认证信息',
    storeName: '店铺名称',
    businessAddress: '经营地址',
    contacts: '联系人',
    tel: '联系手机号',
    change: '修改',
    changeMsg: '修改后,登录账号会一起修改',
    register: '店铺注册时间',
    mainModels: '主营车型',
    mainBrand: '主营品牌',
    area: '主营区域',
    parts: '主营配件',
    IdCard: '法人身份证正面',
    IdCard2: '法人身份证反面',
    businessLicense: '营业执照',
    storeFacade: '店铺门面',

  },

  // 店铺管理——店铺列表
  shopList: {
    list: '店铺列表',
    company: '注册公司',
    status: '公司状态',
    Store: '店铺名称',
    defaultStore: '默认店铺',
    set: '设为默认',
    default: '默认',
  },

  // 店铺管理——店铺信息
  storeInformation: {
    information: '基础信息',
    Main: '主营信息',
    Certification: '认证信息',

    modified: '2022-01-01至2022-12-31内店铺名称一共可以修改3次，您当前还可以修改3次，请谨慎填写',
    Store: '店铺名称',
    management: '经营地址',
    person: '联系人',
    number: '联系手机号',
    registration: '店铺注册时间',
    After: '修改后，登录账号会一起修改',
    Revise: '修改',
    save: '保存',
    province: '请选择省份',
    city: '请选择城市',
    district: '请选择区县',
    you: '请输入您的姓名，方便客户或平台客服与您联系。',
    phone: '联系手机号',
    modification: '修改后，登录账号会一起修改',
    time: '店铺注册时间',

    models: '主营车型',
    brand: '主营品牌',
    area: '主营区域',
    accessories: '主营配件',

    pictures: '暂无图片',
    Front: '法人身份证正面',
    Reverse: '法人身份证反面',
    business: '营业执照',
    shop: '店铺门面',
  },

  // 店铺管理——店铺装修
  StoreConstruction: {
    construction: '店铺装修',
    top: "店铺顶部图片",
    system: "系统会根据上传图片自动调整，可能造成变形。推荐尺寸：1200*100",
    photo: "店铺照片",
    maximum: "(最多添加5张照片，单张照片不超过6M 推荐尺寸100*100)",
    Store: "店铺介绍",
    edit: "编辑",
    Finish: "完成",
    company: '请编辑好公司的情况',
  },

  // 营销管理——店铺活动
  Events: {
    Store: '店铺活动',
    all: '全部',
    progress: '进行中',
    started: '待开始',
    over: '已结束',

    Event: '活动名称',
    Accessory: '配件编码/配件名称',
    reset: '重置',
    Inquire: '查询',
    Check: '查看',
    closure: '关闭',

    // 表格
    Activity: '活动ID',
    operate: '操作',
    name: '名称',
    type: '类型',
    time: '时间',
    Remark: '备注',
    Number: '数量',
    create: '创建信息',
    Modify: '修改信息',

    // 模态框
    Details: '活动详情',
    Purchase: '购买商品1',
    Level: '层级1-满10个赠送',
    product: '商品信息',
    stock: '库存',
    Gift: '赠送数量',
    Starting: '起售数量',
    price: '活动单价',
    search: '搜索',
  },

  // 账号管理——个人资料
  personal: {
    information: '个人资料',
    account: '账号',
    until: '套餐有效期至',
    Package: '套餐名称',
    Name: '姓名',
  },

  // 账号管理——收货地址
  ShippingAddress: {
    address: '收货地址',
    Add: '新增',
    Created: '已创建',
    delivery: '收货地址，还可创建',
    indivual: '个',
    default: '默认地址',
    Revise: '修改',

    // 模态框
    shipping: '设置收货地址',
    Name: '姓名',
    consignee: '请输入收货人姓名',
    Telephone: '电话',
    contact: '请输入联系人电话',
    location: '所在地区',
    province: '请选择省份',
    city: '请选择城市',
    district: '请选择区县',
    Address: '详细地址',
    Please: '请输入详情地址，最多100字',
    set: '设为默认地址',
    Sure: '确定',
    Cancel: '取消',
    as: '设为默认开票信息',
  },

  // 账号管理——发票设置
  Invoice: {
    Sure: '确定',
    Settings: '发票设置',
    Add: '新增',
    Created: '已创建',
    delivery: '发票设置，还可创建',
    indivual: '个',
    address: '默认地址',
    Revise: '修改',
    delete: '删除',
    number: '税号',
    default: '默认',
    Company: '企业名称',
    Are: '您确认删除此开票信息？'
  },

  // 组织管理——员工列表
  staff: {
    list: '姓名',
    Phone: '手机号',
    status: '在职状态',
    Account: '账号状态',
    search: '搜索',
    reset: '重置',
    working: '在职',
    Resign: '离职',
    enable: '启用',
    Disable: '禁用',

    Add: '新增',
    Revise: '修改',
    close: '关闭账号',
    Password: '重置密码',
    Number: '已创建员工数',
    bit: '位',
    also: '还可以创建员工数',

    // 表格
    choose: '选择',
    gender: '性别',
    phoneNumber: '手机号码',
    Role: '角色',
  },

  // 组织管理——角色管理
  Role: {
    number: '序号',
    search: '搜索',
    reset: '重置',
    Add: '新增',
    Revise: '修改',
    delete: '删除',
    Name: '角色名称',
    create: '创建信息',
    Edit: '编辑信息',
    save: '保存',
    Permission: '权限设置'
  },

  //我的关注
  focus: {
    my: '我的关注',
    Full: '全部关注',
    // 表格
    picture: '商品图片',
    info: '商品信息',
    store: '门店',
    place: '发货地',
    stock: '库存',
    price: '价格',
    Purchase: '购买数量',
    operate: '操作',

    // 模态框
    Switch: '切换店铺',
    Company: '公司名称',
    storeName: '店铺名称',
    Role: '角色名称',
    to: '切换',
  },

  // 登录
  login: {
    data1: '欢迎登录',
    data2: '登录',
    data3: '请输入您密码',
    data4: '请输入您的手机号或用户名',
    data5: '推荐使用Chrome浏览器',
    data6: '账号登录',
  },
  // 付款界面
  payOrder: {
    ServiceCashier:'收银台',
    info1:'订单已提交，请在',
    info2:'之内完成支付，否则订单会被',
    info3:'自动取消',
    minute:'分',
    second:'秒',
    moneyinfo:'应付金额：',
    payMethod:'支付方式',
    payMethod1:'线下转账',
    payMethod2:'挂账',
    paySure:'确认付款',
    PaymentDetails:'支付明细',
    orderNo: '订单编号：',
    seller:'卖家',
    transactionTime:'交易时间',
    transactionAmount:'交易金额',
    
    payStatusInfo1:'秒后关闭，即将进入我的【订单页面】重新支付',
    payStatusInfo2:'页面已过期',
    payStatusInfo3: '查看订单',
    payStatusInfo4: '支付失败',
    payStatusInfo5: '支付成功',
    
  }
}
